const features = [
  {
    icon: 'ri-rocket-line',
    title: '极速响应',
    description: '毫秒级数据处理引擎，确保每一次操作都能获得即时反馈，为您打造流畅无等待的使用体验。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '多层安全防护体系，AES-256加密存储与TLS 1.3传输加密，全方位守护您的数据与隐私安全。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端同步',
    description: '支持PC、手机、平板等多设备无缝接入，数据实时同步，随时随地保持高效在线状态。',
  },
  {
    icon: 'ri-brain-line',
    title: '智能推荐',
    description: '基于深度学习的智能推荐引擎，精准理解您的需求，为您呈现最匹配的内容与服务。',
  },
  {
    icon: 'ri-palette-line',
    title: '个性定制',
    description: '丰富的个性化设置选项，自由定制界面主题、功能布局和通知偏好，打造专属工作空间。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专业支持',
    description: '7×24小时专业客服团队随时待命，在线解答您的疑问，确保您的问题得到及时有效处理。',
  },
];

export default function FeatureSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-4">
            核心功能
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-4">
            为什么选择凪光在线
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            六大核心优势，为您提供卓越的在线服务体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${feature.icon} text-xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-950 mb-2">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}